import { memo } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from 'router/routes';
import { ScrollTop } from './scroll-top';

export const AppRoutes = memo(() => {
  return <ScrollTop>{useRoutes(routes)}</ScrollTop>;
});
